module.exports = __webpack_public_path__ + "static/home-hero-5078754f0a04e70bdcfc28f88e10bd89.mp4";